import { createContext } from 'react';

export const PopupContext = createContext<{
  isInPopup: boolean;
  setScrollableContentRef: (node: HTMLElement | null) => void;
  setDefaultScrollableRef?: (node: HTMLElement | null) => void;
}>({
  isInPopup: false,
  setScrollableContentRef: (node: HTMLElement | null) => {
    /* noop */
  },
  /* DO NOT USE THIS - If you are using ModalLayout */
  setDefaultScrollableRef: (node: HTMLElement | null) => {
    /* noop */
  },
});
PopupContext.displayName = 'PopupContext';
